<mat-card class="mb-0">
  <app-card-header [title]="title" [icon]="icon" />

  <ng-container *ngIf="messages && messages.length">
    <mat-card-content>
      <div class="messages-list">
        <app-message *ngFor="let message of messages" [message]="message" />
      </div>
    </mat-card-content>
  </ng-container>
  <ng-container *ngIf="!messages || messages.length == 0">
    <span class="no-items">{{noMessagesText}}</span>
  </ng-container>
  <div #loadMore>
  </div>
</mat-card>
